import { render, staticRenderFns } from "./TestPermissions.vue?vue&type=template&id=fda42588&scoped=true"
import script from "./TestPermissions.vue?vue&type=script&lang=js"
export * from "./TestPermissions.vue?vue&type=script&lang=js"
import style0 from "./TestPermissions.vue?vue&type=style&index=0&id=fda42588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda42588",
  null
  
)

export default component.exports